import { DateService, Month } from '../../services/date.service';
import { Component, Input, OnInit, Injectable, forwardRef, Inject, OnDestroy, ViewChild, ElementRef, Renderer2, } from '@angular/core';
import moment from 'moment';
import { ToasterService } from '../../services/toaster.service';
import { NgbModalRef } from '@otas/modal/modal-ref';
import { NgbModal } from '@otas/modal/modal';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { GlobalUtilService } from '@otas/core/services/global-util.service';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';

@Component({
    selector: 'app-report-header',
    styleUrls: ['./report-header.component.css'],
    template: `
<header style="padding-bottom: 40px;">
  <div class="col-md-12">
  <div class="row hidden-print d-print-none">

    <div class="col-md-9">

    </div>
    <div class="col-md-3 text-md-center">
      <div class="btn-toolbar mt-lg justify-content-end hidden-print d-print-none">
      <ng-content></ng-content>
                    <button title="Print" [print] [tableData]="printData" class="btn btn-sm btn-secondary">
                        <i class="fa fa-print"></i></button>

    <button title="Download" [download] [tableData]="printData" class="btn btn-sm btn-secondary">
        <i class="fa fa-download"></i></button>
    
    <button title="Download Excel" [download] [tableData]="xlsxData" [type]="'xlsx'" class="btn btn-sm btn-secondary">
        <i class="fa fa-file-excel-o"></i></button>

        <button title="Email"  class="btn btn-sm btn-secondary" (click)="mail(email)">
        <i class="fa fa-envelope"></i></button>
                </div>
           </div>
</div>
      <span class="app-report-header text-center">
          <h2 style="font-weight:bold">{{organisationTitle}}</h2>

          <h4 style="font-weight:bold" *ngIf="!!currentUser.isShowInReport">
          <i>{{currentUser.templeAddress}} </i>
          </h4>
          <h4 style="font-weight:bold" *ngIf=" !!dateFrom && !!dateTo && !isSame">
              <i>{{reportName}} {{dateFrom | amUtc | amLocal | amDateFormat: ((formatType=='month')?'MMMM, YYYY': 'DD/MM/YYYY') }}
               - {{dateTo | amUtc | amLocal | amDateFormat:((formatType=='month')?'MMMM, YYYY': 'DD/MM/YYYY') }}</i>
          </h4>
          <h4 style="font-weight:bold" *ngIf=" !FromDate && !ToDate && reportName">
            {{reportName}}
          </h4>
          <h4 style="font-weight:bold" *ngIf="!!dateFrom && !!dateTo && isSame">
              <i>{{reportName}}  {{dateFrom | amUtc | amLocal | amDateFormat:((formatType=='month')?'MMMM, YYYY': 'DD/MM/YYYY')}}</i>
          </h4>
       
      

          <h5 style="font-weight:bold">{{filterName}}</h5>
      </span>
      <span style="z-index: 0; position: absolute; top: 0px;" *ngIf="!!img">
          <img [src]="'data:image/jpeg;base64,' +img" width="75px;;" class="invoice-logo" />
      </span>
  </div>
</header>


<ng-template #email let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4> Send Mail</h4>
    <button type="button" class="btn-close btn-sm" aria-label="Close" (click)="modalRef.dismiss()">
    </button>
  </div>
  <div class="modal-body">
    <form autocomplete="off" class="row" >
      <!-- <hr class="padding-bottom-1x"> -->
      <div class="col-sm-12" #parent5>
        <div class="mb-3" >
          <div class="mb-3">
          <input class="form-control form-control-sm" type="text" [ngModelOptions]="{standalone: true}" [(ngModel)]="emailId">
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button class="btn btn-secondary btn-sm" type="button" (click)="modalRef.dismiss()">cancel</button>
    <button class="btn btn-success btn-sm" type="button" (click)="send()">send mail</button>
  </div>
</ng-template>

`,
    standalone: false
})
export class ReportHeaderComponent implements OnInit, OnDestroy {
  @Input() organisationTitle = 'XXXXXX';
  @Input() dateFrom: Date;
  @Input() dateTo: Date;
  @Input() img;
  @Input() formatType: 'date';

  FromDate: string;
  ToDate: string;
  currentUser;
  emailId;
  isSame: boolean;
  @Input() reportName;
  @Input() printData;
  @Input() xlsxData;
  @Input() filterName;
  modalRef: NgbModalRef;
  downloadClickSub = new Subject();
  downloadData;
  loading = false;
  subscription: Subscription;
  private reportService: ReportService;
  constructor(private globalUtilService: GlobalUtilService, @Inject(forwardRef(() => ReportService)) reportService,
    private toastr: ToasterService, private renderer: Renderer2, private modalService: NgbModal, private elementRef: ElementRef) {
    this.reportService = reportService as ReportService;
  }
  public ngOnInit(): void {

    this.currentUser = JSON.parse(sessionStorage.getItem('CURRENT_USER'));
    if (!!this.currentUser.templeEmail) {
      this.emailId = this.currentUser.templeEmail;
    }
    this.organisationTitle = this.currentUser.templName;
    this.isSame = moment(this.dateTo).isSame(this.dateFrom, 'date');
    this.FromDate = DateService.dateToFormattedString(this.dateFrom);
    this.ToDate = DateService.dateToFormattedString(this.dateTo);
    this.img = this.currentUser.templeLogo;
    this.emailId = this.currentUser.templeEmail;
    this.subscription = this.downloadClickSub.pipe(debounceTime(500)).subscribe(async (data) => {
      try {
        this.toastr.info('Preparing download...', 'Download');
        const base64PDF = await this.globalUtilService.captureAsPDF();
        this.globalUtilService.IPCRendererSend('downloadPDF', base64PDF);
      } catch (e) {
        console.error('Download Error:', e);
        this.toastr.error('Failed to prepare download', 'Error');
      }
    });
  }
  ngAfterContentInit(): void {
    //Called after ngOnInit when the component's or directive's content has been initialized.
    //Add 'implements AfterContentInit' to the class.

  }
  mail(content) {
    this.modalRef = this.modalService.open(content);
  }

  async send() {
    if (this.currentUser.templeEmail !== this.emailId) {
      this.reportService.saveMailId(this.emailId)
        .subscribe(
          response => {
            if (response.status === "SUCCESS") {
              let data = JSON.parse(sessionStorage.getItem('CURRENT_USER'));
              data.templeEmail = this.emailId;
              sessionStorage.setItem('CURRENT_USER', JSON.stringify(data));
            }
          });
    }

    try {
      this.toastr.info('Preparing report for email...', 'Email');

      let base64PDF = null;
      const table = document.querySelector('section.widget table') as HTMLTableElement;
      if (table) {
          base64PDF = await this.globalUtilService.captureTableAsVectorPDF(
              table,
              this.reportName?.trim() || 'Report',
              this.currentUser?.templeAddress || '',
              this.organisationTitle || ''
          );
      } else {
          base64PDF = await this.globalUtilService.captureAsPDF();
      }
      
      const obj: any = { 
        emailId: this.emailId, 
        reportName: this.reportName.trim(),
        pdfData: base64PDF
      };
      
      this.reportService.sendEmailReport(obj).subscribe({
        next: (res) => {
          this.modalRef.close();
          this.toastr.success('Email request sent successfully', 'Success');
        },
        error: (err) => {
          console.error('Email Error:', err);
          this.toastr.error('Failed to send email via backend', 'Error');
        }
      });
    } catch (e) {
      console.error('Email Error:', e);
      this.toastr.error('Failed to prepare email', 'Error');
    }
  }
  ngOnDestroy() {

    if (this.subscription) {
      this.subscription.unsubscribe();
      this.globalUtilService.IPCRendererRemoveAllListeners('dataDownload');
    }

  }
}
@Injectable({
  providedIn: 'root'
})
export class ReportService {
  constructor(private http: HttpClient) { }
  saveMailId(mailId): Observable<any> {
    const obj = { type: "templeemail", value: mailId, id: null, name: null, roles: null };
    return this.http.put<any>(`temple/setting`, obj);
  }

  sendEmailReport(data: { emailId: string, reportName: string, pdfData?: string, htmlBody?: string }): Observable<any> {
    return this.http.post<any>(`report/email`, data);
  }
}

